import type { Language } from '../types/lang';

export const LANGUAGES = {
  RU: 'ru' as Language,
  EN: 'en' as Language,
} as const;

export const DEFAULT_LANGUAGE = LANGUAGES.RU;
